import { DEFAULT_LANGUAGE } from "context/TranslationContext";
import { fetcher } from "helpers/fetcher";

import { TGetListScorecardReq, TGetListScorecardRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getListScorecard = async (
  payload?: TGetListScorecardReq,
  language?: string
) => {
  return await fetcher<TGetListScorecardRes, TGetListScorecardReq["data"]>(
    ENDPOINT.MANAGEMENT.GET_LIST_SCORECARD,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.GET_LIST_SCORECARD.version,
        [API_HEADER.BU_ID]: payload?.idBu,
        [API_HEADER.LANGUAGE]: language,
      },
      data: payload?.data,
      urlData: payload?.data.urlData,
    }
  );
};

export const queryGetListScorecard = async (
  payload?: TGetListScorecardReq,
  language: string = DEFAULT_LANGUAGE
) => {
  return (await getListScorecard(payload, language)).data;
};

queryGetListScorecard._key = (
  payload?: TGetListScorecardReq,
  language: string = DEFAULT_LANGUAGE
) => [ENDPOINT.MANAGEMENT.GET_LIST_SCORECARD.url, payload, language];
